import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createDefaultBucketShippingMethods = {
  name: "createDefaultBucketShippingMethods" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.null(),
};
